import { render, staticRenderFns } from "./Inventorization.vue?vue&type=template&id=2b27e7df&scoped=true&"
import script from "./Inventorization.vue?vue&type=script&lang=js&"
export * from "./Inventorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27e7df",
  null
  
)

export default component.exports